import React, { useState, useEffect, useRef } from 'react';
import "./product-details.css";
import Carousel from 'react-bootstrap/Carousel';
import 'react-multi-carousel/lib/styles.css';

import SecondaryBanner from '../banner/secondary-banner';
import { Col, Form } from 'react-bootstrap';
import { useLocation } from "react-router-dom";
import { getProductsById, imgBaseUrl2, getCreateComment, getCommentBySearch } from '../../utils/api';
import { Rating } from "primereact/rating";
import useToastNotification from '../../hooks/useToastNotification';

// تصاویر و آیکون‌ها
import Star from '../../assets/icons/star.svg';
import DefaultImage from '../../assets/images/products/product-item.jpg';
import Loader from '../../components/loader/dotloader'
import LoaderBtn from '../loader/loader'

import { Toast } from 'primereact/toast';

const Products = () => {
  const location = useLocation();
  const [product, setProduct] = useState(null);
  const [commnets, setComments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [fullName, setFullName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [commentText, setCommentText] = useState('');
  const [rating, setRating] = useState('');
  const [validated, setValidated] = useState(false);
  const toast = useRef(null);
  const [isScrolling, setIsScrolling] = useState(false); // فلگ برای تشخیص اسکرول
  const carouselRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [currentX, setCurrentX] = useState(0);
  const { showError, showSuccess } = useToastNotification();

  // //set error and success message
  // const showError = (error) => {
  //   toast.current.show({ severity: 'error', detail: error.text, life: 6000 });
  // }
  // const showSuccess = (success) => {
  //   toast.current.show({ severity: 'success', detail: success.text, life: 6000 });
  // }
  useEffect(() => {
    const fetchProduct = async () => {
      try {
        setLoading(true)
        const queryParams = new URLSearchParams(location.search);
        const id = queryParams.get("id");
        const res = await getProductsById(id);
        if (res.data.isSuccess) {
          setProduct(res.data.data);
          setLoading(false)
        }
      } catch (error) {
        setLoading(false)
        console.error('Error fetching product:', error);
      }
    };
    fetchProduct();
  }, [location]);


  const getComment = async () => {
    try {
      const queryParams = new URLSearchParams(location.search);
      const id = queryParams.get("id");
      // setLoading(true)
      let res = await getCommentBySearch({
        pageIndex: 0,
        pageSize: 0,
        productId: id
      })
      setComments(res.data.data.items)
    } catch (error) {

    }
  }
  useEffect(() => {
    getComment()
  }, [])
  // آرایه تصاویر محصول (با تصویر پیش‌فرض در صورت نبودن)
  const productImages = (product && product.images && product.images.length > 0) ? product.images : [DefaultImage];
  const cleareData = () => {
    setFullName("");
    setPhoneNumber("");
    setCommentText("");
    setRating("");
    setValidated(false);
  };

  const createComment = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === true) {
      setLoadingBtn(true)
      try {
        const queryParams = new URLSearchParams(location.search);
        const id = queryParams.get("id");
        let pay = {
          fullName: fullName,
          phoneNumber: phoneNumber,
          comment: commentText,
          // rating: rating,
          productId: id
        }
        // check whether user entered ratings
        if (!!rating) {
          pay["rating"] = rating;
        }
        let res = await getCreateComment(pay)
        if (res.data.isSuccess) {

          let message = {
            text: ' دیدگاه شما ثبت شد.'
          }
          showSuccess(message)
          cleareData();
          getComment();
          // setLoading(false)

        } else {
          // setLoading(false)
          let message = {
            text: res.data.message
          }
          showSuccess(message)
          // window.location.href = `/sign-up?mobile=${mobile}`
        }


      } catch (error) {
        // setLoading(false)
        let message = {
          text: 'خطا در ارتباط با سرور'
        }
        showError(message)
      }
      finally {
        setLoadingBtn(false);
      }
    }
    else {
      setValidated(true);
    }
  }

  // برای جلوگیری از فراخوانی بیش از حد در هر حرکت موس
  const throttle = (func, delay) => {
    let lastCall = 0;
    return (...args) => {
      const now = Date.now();
      if (now - lastCall >= delay) {
        lastCall = now;
        func(...args);
      }
    };
  };

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.clientX);
  };

  const handleMouseMove = throttle((e) => {
    if (!isDragging) return;

    setCurrentX(e.clientX);
  }, 16); // مقدار 16ms برای استفاده از throttle و جلوگیری از فراخوانی زیاد تابع

  const handleMouseUp = () => {
    setIsDragging(false);
    const deltaX = currentX - startX;

    if (deltaX > 50) {
      if (carouselRef.current) {
        carouselRef.current.prev(); // اسلاید قبلی
      }


    } else if (deltaX < -50) {
      if (carouselRef.current) {
        carouselRef.current.next(); // اسلاید بعدی
      }


    }

    // ریست مقادیر
    setStartX(0);
    setCurrentX(0);
  };

  return (
    <div>
      <Toast ref={toast} />


      <div>
        <SecondaryBanner slug='Product1' />
      </div>

      <section className='' style={{ position: 'relative' }}>
        <div className='tab-home mt-5 container'>
          <div className='d-flex align-items-center justify-content-between flex-mob-col flex-align'>
            <h1 className='text-3xl font-bold leading-10' style={{ borderBottom: '2px solid #00A14B' }}>محصولات ما</h1>
          </div>

          <div className='slider product-item-slider container mx-0 px-0 mt-5' >
            <div className="flex flex-wrap">
              <Col md={3} sm={12}>
                <div onMouseDown={handleMouseDown}
                  onMouseMove={handleMouseMove}
                  onMouseUp={handleMouseUp}
                  onMouseLeave={() => setIsDragging(false)}
                  style={{ cursor: isDragging ? "grabbing" : "grab" }}>
                  <Carousel
                    interval={5000}
                    ref={carouselRef}
                    controls={false}
                    className="aspect-[16/9]"
                    indicators={productImages && productImages.length > 1}
                  >
                    {productImages.map((image, index) => (
                      <Carousel.Item key={index} className='aspect-[16/9] w-full h-auto'>
                        <div className='img-box'>
                          <img src={imgBaseUrl2 + 'io/' + image.url} draggable={false} className='img-slider' alt={`Product image ${index + 1}`} />

                        </div>
                      </Carousel.Item>
                    ))}
                  </Carousel>
                </div>

              </Col>
              <Col md={9} sm={12}>
                <div className="text-end p-3 max-sm:!text-center">
                <h5 className="font-bold mt-5 text-lg">{product && product.title ? product.title : ''}</h5>
                <div className="mt-4">
                    توضیحات محصول: {product && product.description ? product.description : ''}
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    {
                      product && product.lables && product.lables.length > 0 && product.lables.map((item, index) => (
                        <div key={index}>
                          <h6 className="" dir="rtl">
                            {item}
                            {index < product.lables.length - 1 && ' /'}
                          </h6>
                        </div>
                      ))
                    }
                  </div>



                  <div className='flex gap-1 mt-4'>
                    {/* <img src={Star} alt="" /> */}
                    <Rating value={product ? product.rate : undefined} cancel={false} />

                  </div>
                </div>
              </Col>
            </div>
          </div>
        </div>
      </section>

      <section className='relative mt-5 container'>
        <div className='d-flex align-items-center justify-content-between flex-mob-col flex-align'>
          <h5 className='text-3xl font-bold leading-10' style={{ borderBottom: '2px solid #00A14B' }}>ثبت دیدگاه</h5>
        </div>
        <Form noValidate validated={validated} onSubmit={createComment}>
          <div className="rounded-3xl bg-[#F8F8F8]  row gy-3 p-4 mt-3">
            <div className='col-12'>
              <Rating value={rating} onChange={(e) => setRating(e.value)} cancel={false} />

            </div>
            <div className='col-md-3 col-lg-3 col-sm-6 '>
              <Form.Control
                type="text"
                required
                value={fullName} onChange={(e) => setFullName(e.target.value)}
                placeholder="نام *"
                className='bg-[#fff] focus:outline-none'
              />
            </div>
            <div className='col-md-3 col-lg-3 col-sm-6 '>

              <Form.Control
                type="number"
                required
                value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)}
                placeholder="شماره تماس *"
                className='bg-[#fff] !focus:shadow-0'
              />
            </div>
            <div className=' col-md-3 col-sm-6'>
              <Form.Control
                type="text"
                required
                value={commentText} onChange={(e) => setCommentText(e.target.value)}
                placeholder="دیدگاه شما *"
                className='bg-[#fff] !focus:shadow-0'
              />
            </div>
            <div className='col-sm-6 col-md-3'>

              <button type='submit' className='btn btn-primary w-100  mb-2' style={{ minHeight: '41px' }}>ثبت{loadingBtn && <LoaderBtn />}</button>
            </div>
          </div>
        </Form>
      </section>

      <section className='relative mt-5 container'>
        <div className='d-flex align-items-center justify-content-between flex-mob-col flex-align'>
          <h5 className='text-3xl font-bold leading-10' style={{ borderBottom: '2px solid #00A14B' }}>دیدگاه ها</h5>
        </div>
        {commnets.length > 0 && commnets.map((item, index) => (

          <div className="item py-3 border-b-[#80d0a5] border-b-[1px] last:border-b-0" key={index}>
            <div className="flex gap-1">
              <img src={require('../../assets/icons/user.svg').default} className='w-6' alt="" />
              <div className='font-bold'>
                {item.fullName}
              </div>
            </div>
            <div className='mt-2'>
              {item.comment}
            </div>
          </div>
        )
        )

        }

      </section>
      {loading && <Loader isLoading={loading} />}
    </div>
  );
};

export default Products;
